import React, { useCallback } from 'react';
import { useDispatch } from 'redux-react-hook';

// Redux
import { togglePlaying, playNext, playPrev, setRepeat, shuffle } from 'store/modules/player/actions';

// Components
import PlayerButton from './PlayerButton';
import Pause from 'components/Icon/Pause';
import Play from 'components/Icon/Play';
import Previous from 'components/Icon/Previous';
import Repeat from 'components/Icon/Repeat';
import RepeatAll from 'components/Icon/RepeatAll';
import RepeatOne from 'components/Icon/RepeatOne';
import Suffle from 'components/Icon/Suffle';

export default function Controls({ current, queue, playing, repeat, shaffled }) {
  const dispatch = useDispatch();
  const nextClick = useCallback(() => dispatch(playNext(current, queue)), [queue, current]);
  const prevClick = useCallback(() => dispatch(playPrev(current, queue)), [queue, current]);
  const repeatClick = useCallback(() => dispatch(setRepeat()), []);
  const shuffleClick = useCallback(() => dispatch(shuffle()), []);
  const index = queue.findIndex(sng => sng.id === current.id)
  const RepeatIcon = repeat === 'one' ? RepeatOne : (repeat === 'all' ? RepeatAll : Repeat);

  return (
    <div className="pt-1 pb-2 flex justify-center">
      <PlayerButton onClick={shuffleClick} selected={shaffled}>
        <Suffle width={23} height={23} className="fill-current" />
      </PlayerButton>
      <PlayerButton disabled={index === 0}>
        <Previous onClick={prevClick} width={25} height={25} className="fill-current" />
      </PlayerButton>
      <PlayerButton onClick={() => dispatch(togglePlaying())} selected>
        {!playing && <Play width={25} height={25} className="fill-current" />}
        {playing && <Pause width={25} height={25} className="fill-current" />}
      </PlayerButton>
      <PlayerButton disabled={index === (queue.length - 1)}>
        <Previous onClick={nextClick} width={25} height={25} className="fill-current" style={{ transform: 'rotate(180deg)' }} />
      </PlayerButton>
      <PlayerButton onClick={repeatClick} selected={repeat === 'all' || repeat === 'one'}>
        <RepeatIcon width={24} height={20} className="fill-current" />
      </PlayerButton>
    </div>
  );
}
